const config = {
  traffme: {
    affiliateUrlApi: process.env.REACT_APP_AFFILIATE_API,
    passwordUrlApi: process.env.REACT_APP_PASSWORD_URL,
    USER_API: process.env.REACT_APP_USER_API_URL,
    PERMISSIONS_API: process.env.REACT_APP_PERMISSIONS_API_URL,
    authUrlApi: process.env.REACT_APP_AUTH_API,
    registrationUrlApi: process.env.REACT_APP_REGISTRATION_API,
    apiKey: process.env.REACT_APP_API_KEY,
    affiliateId: process.env.AFF_ID,
  },
};

export default config;
